$(function(){
	var gridLine = $('<div>',{
		class: 'grid-line'
	});
	for (i = 0; i < 11; i++){
		$('body').prepend(gridLine.clone());
	}
});